export default {
  title: 'Dati bancari',
  buttons: {
    save: 'Salva',
  },
  toasts: {
    success: 'Informazioni salvate con successo.',
  },
};
